import {makeStyles, Theme, createStyles} from "@material-ui/core";

const useClasses = makeStyles((theme: Theme) => createStyles({
    root: {
        width: "100%",
    },
    container: {
        display: "flex",
        flexDirection: "column"
    },
    optionsBox: {
        display: "flex",
        justifyContent: "center",
        "& > *": {
            marginRight: theme.spacing(2),
            "& :last-child": {
                marginRight: 0
            }
        }
    },
    stationSelect: {
        width: 150
    },
    dataTypeSelect: {
        width: 220
    }
}));

export default useClasses;
